import { chatService } from './chatService';

// Types for the chat API - matches the actual API response
export interface ChatApiResponse {
  requestId: string;
  sessionId: string;
  message: {
    role: 'assistant';
    content: Array<{ text: string }>;
  };
}

// Environment variables
const CHAT_MOCK_MODE = import.meta.env.VITE_CHAT_MOCK_MODE === 'true';
const CHAT_BOT_ID = import.meta.env.VITE_CHAT_BOT_ID;

// Mock response for development
const generateMockResponse = (message: string, sessionId?: string): ChatApiResponse => {
  let mockText = "Thank you for your message! This is a mock response from the Fabrik 28 AI assistant.";
  
  if (message.toLowerCase().includes('hello') || message.toLowerCase().includes('hi')) {
    mockText = "Hello! Welcome to Fabrik 28. I'm here to help you automate your business workflows. What would you like to know about our AI solutions?";
  } else if (message.toLowerCase().includes('price') || message.toLowerCase().includes('cost')) {
    mockText = "Our pricing is flexible and scales with your business. We offer a free trial to get you started, then plans starting from $29/month. Would you like to schedule a demo to discuss your specific needs?";
  } else if (message.toLowerCase().includes('demo')) {
    mockText = "I'd be happy to arrange a demo for you! Our demos typically take 15-20 minutes and show you exactly how Fabrik 28 can automate your specific workflows. Would you prefer a live demo or a recorded walkthrough?";
  }
  
  return {
    requestId: "mock-request-" + Date.now(),
    sessionId: sessionId || "mock-session-" + Date.now(),
    message: {
      role: "assistant",
      content: [{ text: mockText }]
    }
  };
};

// Chat API that matches the expected interface
export const chatApi = {
  async sendMessage(message: string, sessionId?: string): Promise<ChatApiResponse> {
    if (CHAT_MOCK_MODE) {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 800));
      return generateMockResponse(message, sessionId);
    }

    try {
      // Use the chat service with sessionId support
      const response = await chatService.sendChatMessage({
        message,
        botId: CHAT_BOT_ID,
        sessionId: sessionId // Pass sessionId for subsequent messages
      });

      // The response now matches the actual API structure
      return response;
    } catch (error) {
      throw error;
    }
  }
};
